<!--========== 教学分析评估报告管理 ==========-->
<template>
    <div class="app-container">
        <el-card class="mb15" :body-style="{ padding: '10px' }">
            <div class="top1-container">
                <div class="top1-left">{{info.orgName}}
                    <span v-if="info.resourceType===0" style="font-size: 15px;color: #bd3124">(试用)</span>
                    <span v-if="info.resourceType===1" style="font-size: 15px;color: #67c23a">(正式)</span>
                    <el-dropdown v-if="orgList&&orgList.length>1">
                        <svg t="1754635295400" class="icon cursor" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6838" width="28" height="28" style="margin-left: 5px;"><path d="M720.544687 402.905326 720.544687 402.905326 720.544687 402.905326l-84.467787-84.46267c-6.951319-6.956436-18.841114-2.031263-18.841114 7.79964l0 65.626673c0 6.095835-4.938476 11.036357-11.036357 11.036357L282.375206 402.905326c-6.092765 0-11.036357 4.938476-11.036357 11.036357l0 29.581736c0 6.092765 4.938476 11.036357 11.036357 11.036357l463.178061 0c9.830903 0 14.755052-11.889795 7.804756-18.84009L720.544687 402.905326 720.544687 402.905326 720.544687 402.905326zM720.544687 402.905326" fill="#4167f7" p-id="6839"></path><path d="M307.317271 621.089557 307.317271 621.089557 307.317271 621.089557l84.467787 84.467787c6.951319 6.950296 18.841114 2.031263 18.841114-7.804756l0-65.626673c0-6.092765 4.943592-11.036357 11.036357-11.036357l323.839573 0c6.095835 0 11.040451-4.939499 11.040451-11.036357l0-29.577642c0-6.095835-4.944616-11.036357-11.040451-11.036357L282.308691 569.4392c-9.834996 0-14.755052 11.884678-7.800663 18.841114L307.317271 621.089557 307.317271 621.089557 307.317271 621.089557zM307.317271 621.089557" fill="#4167f7" p-id="6840"></path><path d="M513.928932 947.106726c-239.914138 0-435.104679-195.186448-435.104679-435.109796 0-239.913115 195.190541-435.103656 435.104679-435.103656 239.917208 0 435.108772 195.190541 435.108772 435.103656C949.037704 751.920278 753.847164 947.106726 513.928932 947.106726L513.928932 947.106726zM513.928932 112.605637c-220.22368 0-399.393339 179.164542-399.393339 399.391293 0 220.22368 179.164542 399.396409 399.393339 399.396409 220.227774 0 399.396409-179.172729 399.396409-399.396409C913.326365 291.774273 734.156706 112.605637 513.928932 112.605637L513.928932 112.605637zM513.928932 112.605637" fill="#4167f7" p-id="6841"></path></svg>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item :disabled="orgId===item.orgId" v-for="item in orgList" @click="changeOrg(item)">{{item.orgName}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </div>
                <div class="top1-right">{{info.totalCount - info.usedCount}}</div>
            </div>
            <div class="top2-container">
                <div class="top2-left">管理员:{{info.orgAdminName}}</div>
                <div class="top2-right">剩余次数</div>
            </div>
        </el-card>

        <el-card class="mb15" :body-style="{ padding: '10px' }">
            <div class="title-container">充值及消耗记录</div>
            <div class="bre9e mt15">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          height="calc(100vh - 490px)"
                          :data="recordList"
                          highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column align="center" label="操作时间" prop="createTime">
                        <template #default="scope">
                            <div>{{ timestampToTime(scope.row.createTime)}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作类型" prop="recordType">
                        <template #default="scope">
                            <div class="s-cz" v-if="scope.row.recordType===1">充值</div>
                            <div class="s-xh" v-if="scope.row.recordType===0">消耗</div>
                        </template>
                    </el-table-column>
                    <el-table-column  align="center" label="操作人">
                        <template #default="scope">
                            <div  v-if="scope.row.recordType===1">--</div>
                            <div  v-if="scope.row.recordType===0">{{scope.row.trueName}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column  align="center" label="充值人">
                        <template #default="scope">
                            <div  v-if="scope.row.recordType===1">{{scope.row.trueName}}</div>
                            <div  v-if="scope.row.recordType===0">--</div>
                        </template>
                    </el-table-column>
                    <el-table-column  align="center" label="次数变动">
                        <template #default="scope">
                            <div  v-if="scope.row.recordType===1">+{{scope.row.recordNum}}{{scope.row.resourceType===0?'(试用)':'(正式)'}}</div>
                            <div  v-if="scope.row.recordType===0">-{{scope.row.recordNum}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-card>

        <el-card class="mb15" :body-style="{ padding: '10px' }">
            <div class="title-container">
                <div class="tc-l">订单记录</div>
                <div class="tc-r">
                    <el-button type="primary" size="small" style="background-color: #3b82f6;border-color: #5c89ff;" @click="handleCreate">+教学分析</el-button>
                </div>
            </div>
            <div class="bre9e mt15">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          height="calc(100vh - 490px)"
                          :data="taskList"
                          highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column width="80" align="center" label="状态" prop="taskStatus">
                        <template #default="scope">
                            <div v-if="scope.row.taskStatus === '0'">待分析</div>
                            <div v-if="scope.row.taskStatus === '1'">分析中</div>
                            <div v-if="scope.row.taskStatus === '2'">已分析</div>
                            <div v-if="scope.row.taskStatus === '-1'">分析失败</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="140" align="center" label="操作时间" prop="Time">
                        <template #default="scope">
                            <div>{{ timestampToTime(scope.row.createTime)}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column  align="center" label="操作人" prop="createUserName"></el-table-column>
                    <el-table-column width="160"  align="center" label="视频名称" prop="taskName" ></el-table-column>
                    <el-table-column  align="center" label="授课教师" prop="trueName"></el-table-column>
                    <el-table-column  align="center" label="学段" prop="periodName"></el-table-column>
                    <el-table-column  align="center" label="学科" prop="subjectName"></el-table-column>
                    <el-table-column width="160"  align="center" label="量表" prop="scaleName"></el-table-column>
<!--                    <el-table-column fixed="right" width="120" label="操作" align="center">-->
<!--                        <template #default="scope">-->
<!--                            <el-button v-if="scope.row.taskStatus==='2'" type="primary" size="small" @click="handleDetail(scope.row)">查看报告</el-button>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                </el-table>
            </div>
        </el-card>
    </div>
</template>

<script>
import {timestampToTime} from "@/utils/date";
import {orgAnalyseDetail} from "@/api/admin/analyseResource"


export default {
    name: "orgAnalyseDetail",
    components: {},
    data() {
        return {
            timestampToTime,
            orgId:'',
            orgList:[],
            info:{},
            recordList:[],// 重置及消耗记录列表
            taskList:[],//分析任务列表
        };
    },
    created() {
        if (this.$route.query.signId) {
            this.orgId = this.$route.query.signId;
        }
       this.queryOrgAnalyseDetail()
    },
    activated() {},
    watch: {},
    methods: {
        queryOrgAnalyseDetail(){
            orgAnalyseDetail().then(res => {
                if (res.data.code === 1) {
                    this.orgList = res.data.data;
                    if (this.orgList&&this.orgList.length>0){
                        if (this.orgId&&this.orgId.length>0){
                            this.orgList.forEach(item => {
                                if (this.orgId === item.orgId){
                                    this.info = item;
                                }
                            })
                        }else {
                            this.info = this.orgList[0];
                        }

                        this.orgId = this.info.orgId;
                        this.recordList = this.info.recordList;
                        this.taskList = this.info.taskList;
                    }
                }else {
                    this.$message.error("请求出错");
                }
            })
        },
        changeOrg(item){
            this.info = item;
            this.orgId = this.info.orgId;
            this.recordList = this.info.recordList;
            this.taskList = this.info.taskList;
        },
        handleCreate(){
            const num = this.info.totalCount - this.info.usedCount;
            if (num<=0){
                this.$message.error("教学分析额度已耗尽，请联系管理员");
                return;
            }
            this.$router.push({
                path: "/analyseTaskCreate",
                query: {
                    signId: this.orgId,
                }
            });
        },
        handleDetail(row){
            this.$router.push({
                path: "/analyseReport",
                query: {
                    taskId: row.taskId,
                }
            });
        }
    }
};
</script>
<style scoped>
.top1-container{
    width: 100%;
    height: 30px;
    display: flex;
}
.top1-left{
    width: calc(100% - 100px);
    height: 100%;
    font-size: 18px;
    font-weight: bold;
    font-family: sans-serif;
    text-align: left;
    color: #121212;
}
.top1-right{
    width: 100px;
    height: 100%;
    font-size: 18px;
    font-weight: bold;
    font-family: sans-serif;
    text-align: center;
    color: #4167f7;
}
.top2-container{
    width: 100%;
    height: 20px;
    display: flex;
}
.top2-left{
    width: calc(100% - 100px);
    height: 100%;
    font-size: 14px;
    font-family: sans-serif;
    text-align: left;
    color: #383838;
}
.top2-right{
    width: 100px;
    height: 100%;
    font-size: 14px;
    font-family: sans-serif;
    text-align: center;
    color: #383838;
}
.title-container{
    color:#121212;
    font-weight:bold;
    font-size:15px;
    font-family: sans-serif;
    height: 20px;
    display: flex;
}

.tc-l{
    width: calc(100% - 100px);
    color:#121212;
    font-weight:bold;
    font-size:15px;
    font-family: sans-serif;
    height: 20px;
    display: flex;
}
.tc-r{
    width: 100px;
}
.s-cz{
    font-family: sans-serif;
    font-size: 12px;
    color: #fff;
    width: 46px;
    height: 24px;
    line-height: 24px;
    border-radius: 4px;
    text-align: center;
    background-color: #67c23a;
    margin: auto;
}
.s-xh{
    font-family: sans-serif;
    font-size: 12px;
    color: #fff;
    width: 46px;
    height: 24px;
    line-height: 24px;
    border-radius: 4px;
    text-align: center;
    background-color: #bd3124;
    margin: auto;
}
</style>
